import React from 'react';
import PropTypes from 'prop-types';
import { AiOutlineRight, AiOutlineLeft } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const Pagination = ({ page = 1, totalPages, changePage }) => {
  const nextPage = () => {
    changePage(page + 1);
  };

  const previousPage = () => {
    changePage(page - 1);
  };

  const { t } = useTranslation(['backoffice']);

  return (
    <div className="d-flex justify-content-center pagination-userzone mt-3">
      <AiOutlineLeft
        onClick={page > 1 ? previousPage : null}
        className={`button ${page > 1 ? 'active' : 'disabled'} m-2`}
      />
      <li className="m-2 text-pagination list-unstyled">
        {t('page')} {page} {t('of')} {totalPages}
      </li>
      <AiOutlineRight
        onClick={page < totalPages ? nextPage : null}
        className={`button ${page < totalPages ? 'active' : 'disabled'} m-2`}
      />
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func,
};

export default Pagination;
